export enum ThemesNames {
  Blue = 'blue',
  Dark = 'dark',
  Gray = 'gray',
  White = 'white',
}
